export default {
      id: "ruler-vertical-usage",
      viewBox: "0 0 256 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#ruler-vertical",
      toString: function () {
        return this.url;
      }
    }